import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { useLocation } from "@tanstack/react-router";
import { Wrench } from "lucide-react";
import type { ReactNode } from "react";
import { getMaintenancePublic } from "@/lib/admin-platform.functions";
import { useIsAdmin } from "@/hooks/use-my-profile";

export function MaintenanceGate({ children }: { children: ReactNode }) {
  const loadFn = useServerFn(getMaintenancePublic);
  const isAdmin = useIsAdmin();
  const location = useLocation();
  const { data } = useQuery({
    queryKey: ["maintenance-public"],
    queryFn: () => loadFn(),
    staleTime: 60_000,
  });

  // Always allow admin routes through (admins manage maintenance from there).
  const isAdminRoute = location.pathname.startsWith("/admin");
  if (!data?.enabled || isAdmin || isAdminRoute) return <>{children}</>;

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-lg text-center">
        <div className="mx-auto mb-6 inline-flex items-center justify-center rounded-2xl border border-primary/40 bg-primary/10 p-4 text-primary">
          <Wrench className="h-8 w-8" />
        </div>
        <h1 className="text-2xl font-bold tracking-tight">We'll be right back</h1>
        <p className="mt-3 whitespace-pre-line text-sm text-muted-foreground">
          {data.message}
        </p>
      </div>
    </div>
  );
}
